import React, { Fragment } from 'react';
import { i18n } from 'core/i18n';
const { FormattedText } = i18n;

const FeatureSection = ({ icon, title = '', itemList = [] }) => {
    return (
        <Fragment>
            <div className="prospects-gutter prospects-prepend-margin basic-layering">
                <div className="container documentation-info-view__tcBanner">
                    <h3 className="font-heading3">{title}</h3>
                    <span className="dash-blue" />
                    <div className="row">
                        <div className="col-md-8 col-sm-8">
                            <ul>
                                {itemList.map(item => (
                                    <li key={title}>
                                        <span className="documentation-info-view__tcBanner__item-title">
                                            <FormattedText value={item} />
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="col-md-4 col-sm-4 documentation-info-view__tcBanner-img">
                            <img src={icon} />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default FeatureSection;
